import { DashboardBaseDataProvider } from './DashboardBaseDataProvider';
import { sanitizeObject } from '../../utils/sanitization.utils';
import { GetCompaniesResponse, GetWidgetsForDashboardResponse } from '@nirvana/shared/dtos/types/dashboards/gz-console';
import {
  GetExecutiveSummaryPdfRequest,
  GetExecutiveSummaryPdfResponse,
} from '@nirvana/shared/dtos/types/dashboards/common';
import { TimeRange } from '@nirvana/shared/dtos/types/shared/time';
import { getRequestDefaultOptions } from '../../utils/request.utils';

export class DashboardNirvanaDataProvider extends DashboardBaseDataProvider {
  async setTimeRange(params: { dashboardId: string; timeRange: TimeRange }): Promise<{} | undefined> {
    const response = await this.dependencies.api.clients.Dashboards.setTimeRange(
      {
        dashboardId: params.dashboardId,
        timeRange: params.timeRange,
      },
      getRequestDefaultOptions()
    ).toPromise();

    return sanitizeObject(response);
  }

  async setTargets(params: { dashboardId: string; targets: Array<string> }) {
    const response = await this.dependencies.api.clients.Dashboards.setTargets(
      {
        dashboardId: params.dashboardId,
        targets: params.targets,
      },
      getRequestDefaultOptions()
    ).toPromise();

    return sanitizeObject(response);
  }

  async getWidgetsForDashboard(params: { dashboardId: string }): Promise<GetWidgetsForDashboardResponse | undefined> {
    const response = await this.dependencies.api.clients.Dashboards.getWidgetsForDashboard(
      {
        dashboardId: params.dashboardId,
      },
      getRequestDefaultOptions()
    ).toPromise();

    return sanitizeObject(response);
  }

  async getCompanies(params: { companyName: string }): Promise<GetCompaniesResponse | undefined> {
    const response = await this.dependencies.api.clients.Dashboards.getCompanies(
      {
        companyName: params.companyName,
      },
      getRequestDefaultOptions()
    ).toPromise();

    return sanitizeObject(response);
  }

  async getExecutiveSummaryPdf(params: GetExecutiveSummaryPdfRequest): Promise<GetExecutiveSummaryPdfResponse> {
    const response = await this.dependencies.api.clients.Dashboards.getExecutiveSummaryPdf(
      params,
      getRequestDefaultOptions()
    ).toPromise();
    return sanitizeObject(response);
  }
}
